import { TbArrowsRightLeft } from 'react-icons/tb'
import { FaExchangeAlt } from 'react-icons/fa'
import { customerHelper } from '@tweddle-se-team/common/constants'
import { customerId } from '@/utils/env'

const { CUSTOMER_IDS } = customerHelper

const changeVehicleIconByCustomer = {
  [CUSTOMER_IDS.TME]: TbArrowsRightLeft,
  [CUSTOMER_IDS.SUBARU]: TbArrowsRightLeft,
  [CUSTOMER_IDS.NORDICS]: FaExchangeAlt
}

const ChangeVehicleIcon = props => {
  const Icon = changeVehicleIconByCustomer[customerId] || changeVehicleIconByCustomer[CUSTOMER_IDS.TME]

  return <Icon {...props} />
}

export default ChangeVehicleIcon
